export default __webpack_public_path__ + "static/media/ico_createAdm.25f537e9.svg";